module.exports = __webpack_public_path__ + "img/qidian.4a2bac4e.png";